var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddMoreTertiary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_992651",
    clipPath: "url(#clip0_7060_84516)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 0C4.0371 0 0 4.0371 0 9C0 13.9629 4.0371 18 9 18C13.9629 18 18 13.9622 18 9C18 4.0378 13.9629 0 9 0ZM9 16.6057C4.80674 16.6057 1.39426 13.194 1.39426 9C1.39426 4.80604 4.80674 1.39426 9 1.39426C13.1933 1.39426 16.6057 4.80604 16.6057 9C16.6057 13.194 13.194 16.6057 9 16.6057Z",
    fill: "#667085"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.4888 8.24007H9.70028V5.45154C9.70028 5.06672 9.38866 4.75439 9.00313 4.75439C8.61761 4.75439 8.30598 5.06672 8.30598 5.45154V8.24007H5.51746C5.13194 8.24007 4.82031 8.55239 4.82031 8.93721C4.82031 9.32203 5.13194 9.63436 5.51746 9.63436H8.30598V12.4229C8.30598 12.8077 8.61761 13.12 9.00313 13.12C9.38866 13.12 9.70028 12.8077 9.70028 12.4229V9.63436H12.4888C12.8743 9.63436 13.186 9.32203 13.186 8.93721C13.186 8.55239 12.8743 8.24007 12.4888 8.24007Z",
    fill: "#667085"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7060_84516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMoreTertiary);
export default __webpack_public_path__ + "static/media/add_more_tertiary.b68c0db0e573c1edbeec752e6abf8279.svg";
export { ForwardRef as ReactComponent };